import { singleton } from "logic/singleton";
import standardMapper from "logic/permissions/StandardEntityPermissionsMapper";
class EntityPermissionsMapperBinder {
  static register(implementingClass) {
    this.__registrations.push(implementingClass);
  }
  static mapToPrefix(type, id) {
    const mapForIdAndType = this.__registrations.map((mapper) => mapper.mapForIdAndType(id, type)).find((prefix) => prefix !== void 0);
    return mapForIdAndType || this.__registrations.map((mapper) => mapper.mapForType(type)).find((prefix) => prefix !== void 0);
  }
}
EntityPermissionsMapperBinder.__registrations = [standardMapper];
const SingletonEntityPermissionsMapperBinder = singleton(
  "logic.entitypermissionsmapper.binder",
  () => EntityPermissionsMapperBinder
);
export default SingletonEntityPermissionsMapperBinder;
